<template>
  <div id="app">
    <Header></Header>
    <router-view/>
  </div>
</template>

<script>
import Header from './components/Header.vue';

export default {
  /**
   * Родительский компонент приложения
   */
  components: {
    Header,
  },
};
</script>

<style lang="scss">
  @import 'assets/css/bootstrap.min.css';
  @import 'assets/css/main';
  @import 'assets/css/reset.css';
  @import 'assets/css/icons.css';
  #app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: white;
  min-height: 100vh;
}
body{
  background: $body_bg;
  color: white;
}
#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
